/**
 * Matcher for "first_session" condition.
 * @module
 */
module.exports = {
  fieldsNeeded: ['first_session'],

  /**
   * If there are no events or if all events are in same session, return true.
   * @param {Object} value
   * @returns {boolean}
   */
  match: function(value:any): boolean {
    return !!value.first_session;
  }
};
